<template>
    <div class="cal">
        <div @click="showCal"
             class="cal-show">
            <div>
                {{formatDate}}
            </div>
            <img class="cal-arrow" 
                 src="../../assets/img/arrow2cal.png" 
                 v-bind:class="{ 'reverse-arrow': fold}"
                 >
        </div>
        <div class="cal-main" v-bind:class="{ 'show-main': fold}">
            <div class="cal-title">
              <img class="arrow-img" src="../../assets/img/arrow2left.png" @click="changeYear(false)">
              <img class="arrow-img" src="../../assets/img/arrow2prev.png" @click="changeMonth(false)">
              <span class="title-content" >{{calTitle}}</span>
              <img class="arrow-img" src="../../assets/img/arrow2next.png" @click="changeMonth(true)">
              <img class="arrow-img" src="../../assets/img/arrow2right.png" @click="changeYear(true)">
            </div>
            <ul class="cal-content">
              <li class="cal-date">日</li>
              <li class="cal-date">一</li>
              <li class="cal-date">二</li>
              <li class="cal-date">三</li>
              <li class="cal-date">四</li>
              <li class="cal-date">五</li>
              <li class="cal-date">六</li>
              <li class="cal-date passive-date" 
                v-for="(item) in allMonth.prev" 
                :key='item.date' 
                @click="changeMonth(false)">{{item.num}}</li>
              <li class="cal-date current-date" 
                v-bind:class="{ 'selected': date === item.date ,'passive-date':!item.exist }" 
                v-for="(item) in allMonth.current" 
                @click="clickDate(item.date)"
                :key='item.date'>{{item.num}}</li>
              <li class="cal-date passive-date" 
              v-for="(item) in allMonth.next" 
              :key='item.date' 
              @click="changeMonth(true)">{{item.num}}</li>
            </ul>
            <!-- <div class="cal-bottom" @click="getDatelist()">
              最近更新数据日期
            </div> -->

        </div>
        <div></div>
    </div>
</template>

<script>
export default {
  name: "calendar",
  props: ["date", "dateList", "type", "currDate"],
  created: function() {
    document.addEventListener("click", e => {
      if (!this.$el.contains(e.target)) this.fold = false;
    });
  },
  data() {
    return {
      fold: false,
      currentDate: {
        month: "",
        year: ""
      },
      allMonth: {
        prev: [],
        current: [],
        next: []
      }
    };
  },

  methods: {
    showCal() {
      if (!this.fold) {
        let arr = this.date.split("");
        this.currentDate.year = arr.slice(0, 4).join("");
        this.currentDate.month = arr.slice(4, 6).join("") - 0;
        this.monthArray();
      }
      this.fold = !this.fold;
    },
    changeMonth(bol) {
      if (bol) {
        this.currentDate.month++;
      } else {
        this.currentDate.month--;
      }
      if (this.currentDate.month >= 13) {
        this.changeYear(true);
        this.currentDate.month = 1;
      } else if (this.currentDate.month <= 0) {
        this.changeYear(false);
        this.currentDate.month = 12;
      }
      this.monthArray();
    },
    changeYear(bol) {
      if (bol) {
        this.currentDate.year++;
      } else {
        this.currentDate.year--;
      }
      this.getDatelist();
    },
    getDatelist() {
      let type = this.type === "lgt" ? 1 : 2;
      $.ajax({
        type: "GET",
        url: "//zx.10jqka.com.cn/offshorefunds/hsgttradeday/alltradeday",
        data: {
          year: this.currentDate.year,
          type: 1
        },
        dataType: "jsonp",
        success: data => {
          if (data.error_code) {
            console.log(data.error_msg);
          }
          let dateList = data.result;
          let t = $util.time.format(this.currDate, "");

          let arr = [];
          for (let i = 0; i < dateList.length; i++) {
            if (dateList[i] - 0 < t - 0 && dateList[i] - 0 > 20170106) {
              arr.push(dateList[i]);
            }
          }
          dateList = arr;
          this.$emit("update:dateList", dateList);
          setTimeout(this.monthArray, 10);
        },
        error: function(e) {
          console.log(e);
        }
      });
      // axios.get("//zx.10jqka.com.cn/offshorefunds/hsgttradeday/allmarkettradeday",{
      //     params: {
      //       year: this.currentDate.year,
      //       type: 1
      //     }
      //   })
      //   .then(data => {
      //     data = data.data
      //     if (data.error_code) {
      //       console.log(data.error_msg);
      //     }
      //     let dateList = data.result;
      //     let t = $util.time.format(this.currDate, "");

      //     let arr = [];
      //     for (let i = 0; i < dateList.length; i++) {
      //       if (dateList[i] - 0 < t - 0 && dateList[i] -0 > 20170106) {
      //         arr.push(dateList[i]);
      //       }
      //     }
      //     dateList = arr;
      //     this.$emit("update:dateList", dateList);
      //     setTimeout(this.monthArray, 10);

      //   })
      //   .catch(function (error) {
      //     console.log(error);
      // });
    },
    clickDate(date) {
      if (this.dateList.indexOf(date) < 0) return;

      this.$emit("update:date", date);
      this.fold = false;
      if (this.dateList.indexOf(date) === this.dateList.length - 1) return;
      if (this.type === "lgt") {
        TA.log({ id: "cgpz_lgt_lssj" });
      } else {
        TA.log({ id: "cgpz_ggt_lssj" });
      }
    },
    //返回选择月份的日趋个数
    monthDaysCount(year, month) {
      var yearMonthDay = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; //平年每个月的总天数;
      if ((year % 4 == 0 && year % 100 != 0) || year % 400 == 0) {
        if (month === 2) {
          return yearMonthDay[month - 1] + 1;
        } else {
          return yearMonthDay[month - 1];
        }
      } else {
        return yearMonthDay[month - 1];
      }
    },
    monthArray() {
      this.pushPrevMonth();
      this.pushCurrentMonth();
      this.pushNextMonth();
    },
    pushPrevMonth() {
      this.allMonth.prev = []; // 初始化
      let year = this.currentDate.year;
      let month = this.currentDate.month;
      var firstDayDate = new Date(year, month - 1, 1).getDay(); //获取月份第一天礼拜几
      let previousDaysCount;

      if (month == 1) {
        previousDaysCount = this.monthDaysCount(year - 1, 12);
      } else {
        previousDaysCount = this.monthDaysCount(year, month - 1);
      }
      for (
        var i = previousDaysCount - firstDayDate + 1;
        i <= previousDaysCount;
        i++
      ) {
        if (month == 1) {
          var date = year - 1 + "12";
          date += i > 9 ? i : "0" + i;
        } else {
          var date = year + "";
          date += month - 1 > 9 ? month - 1 : "0" + (month - 1);
          date += "";
          date += i > 9 ? i : "0" + i;
        }

        let t = {
          date: date,
          num: i
        };
        this.allMonth.prev.push(t);
      }
    },
    pushCurrentMonth() {
      this.allMonth.current = []; // 初始化
      let year = this.currentDate.year;
      let month = this.currentDate.month;
      let nowDaysCount = this.monthDaysCount(year, month);

      for (var i = 1; i <= nowDaysCount; i++) {
        var date = year + "";
        date += month > 9 ? month : "0" + month;
        date += "";
        date += i > 9 ? i : "0" + i;
        let exist = false;
        if (this.dateList.indexOf(date) >= 0) {
          exist = true;
        }
        let t = {
          date: date,
          num: i,
          exist: exist
        };
        this.allMonth.current.push(t);
      }
    },
    pushNextMonth() {
      this.allMonth.next = []; // 初始化
      let year = this.currentDate.year;
      let month = this.currentDate.month;
      var lastDayDate =
        new Date(year, month, 1).getDay() == 0
          ? 6
          : new Date(year, month, 1).getDay() - 1; //获取月份最后一天礼拜几
      if (lastDayDate < 6) {
        for (var i = 1; i < 7 - lastDayDate; i++) {
          if (month == 12) {
            var date = year - 0 + 1 + "01";
            date += i > 9 ? i : "0" + i;
          } else {
            var date = year + "";
            date += month + 1 > 9 ? month + 1 : "0" + (month + 1);
            date += "";
            date += i > 9 ? i : "0" + i;
          }
          let t = {
            date: date,
            num: i
          };
          this.allMonth.next.push(t);
        }
      }
    }
  },
  computed: {
    calTitle() {
      let year = this.currentDate.year;
      let month = this.currentDate.month;
      return year + "年 " + month + "月";
    },
    judgeCurrent() {
      let arr = this.date.split("-");
      return "" + arr[0] + arr[1] + arr[2];
    },
    formatDate() {
      console.log(this.date);
      var arr = this.date.split("");
      arr.splice(4, 0, "-");
      arr.splice(7, 0, "-");
      return arr.join("");
    }
  }
};
</script>

<style scoped>
.cal {
  position: relative;
}
.cal-show {
  width: 120px;
  height: 20px;
  font-size: 12px;
  line-height: 21px;
  padding: 0 6px;
  position: relative;
  cursor: pointer;
  margin: 0 7px;
}
.cal-arrow {
  position: absolute;
  transition: all 1s;
  transition-timing-function: ease;
  width: 7px;
  height: 4px;
  top: 9px;
  right: 10px;
}
.cal-main {
  position: absolute;
  top: 35px;
  left: -66px;
  width: 210px;
  background-color: #ffffff;
  border-radius: 4px;
  /* transition: all 1s; */
  max-height: 0px;
  overflow: hidden;
  z-index: 999;
}
.show-main {
  max-height: 300px;
  border: 1px solid;
  box-sizing: content-box;
}
.cal-title {
  text-align: center;
  color: #000000;
  height: 30px;
  border-bottom: 1px solid #ccc;
  padding: 5px;
}
.title-content {
  position: relative;
  top: -3px;
  display: inline-block;
  line-height: 20px;
  width: 108px;
}
.cal-content {
  display: flex;
  flex-wrap: wrap;
}
.arrow-img {
  height: 16px;
  cursor: pointer;
}
.cal-date {
  width: 20px;
  height: 20px;
  text-align: center;
  color: #5a5d5a;
  background-color: #fffbff;
  margin: 5px;
  border-radius: 2px;
  cursor: pointer;
}
.passive-date {
  color: #cecfce;
  cursor: default;
}
.selected {
  background-color: #0886de;
  color: #ffffff;
}
.current-date:hover {
  background-color: #eff7ff;
  border: 1px solid #cee7ff;
}
.passive-date:hover {
  background-color: #ffffff;
  border: none;
}
.selected:hover {
  background-color: #0886de;
  color: #ffffff;
  border: 1px solid #cee7ff;
}
.cal-bottom {
  height: 30px;
  text-align: center;
  color: #0886de;
  line-height: 30px;
  cursor: pointer;
  border-top: 1px solid #ccc;
}
</style>


// WEBPACK FOOTER //
// src/components/mod/calendar.vue